export const WORKFLOW_STAGE_SEQUENCE_STEP = 100;

export const WORKFLOW_STAGE_DESCRIPTION_MAX_LENGTH = 255;

export const WORKFLOW_STAGE_STATUS_DOT_COLORS = [
  '#20b24f',
  '#d42215',
  '#f7941e',
  '#0c4e8d',
  '#2e4dd4',
  '#00ccf2',
  '#eb3520',
  '#37cc95',
];

export {
  LOAN_APPLICATION_STAGES_STATUS_TYPE_ID as WORKFLOW_STAGE_MASTER_STATUS_TYPE_ID,
  LOAN_APPLICATION_STATUS_STATUS_TYPE_ID as WORKFLOW_STAGE_STATUS_MASTER_STATUS_TYPE_ID,
} from './loanApplication.constants';
